import { createContext, type ReactNode, useContext } from 'react';
import { useGiayBaoNoExport } from '../hooks';

interface GiayBaoNoSearchContextValue {
  exportToExcel: () => Promise<void>;
  canExport: boolean;
  isExporting: boolean;
}

const GiayBaoNoSearchContext = createContext<GiayBaoNoSearchContextValue | null>(null);

export function useGiayBaoNoSearchContext() {
  const context = useContext(GiayBaoNoSearchContext);
  if (!context) {
    throw new Error('useGiayBaoNoSearchContext must be used within GiayBaoNoSearchProvider');
  }
  return context;
}

export function GiayBaoNoSearchProvider({ children }: { children: ReactNode }) {
  const { exportToExcel, canExport, isExporting } = useGiayBaoNoExport();

  return (
    <GiayBaoNoSearchContext.Provider
      value={{
        exportToExcel,
        canExport,
        isExporting
      }}
    >
      {children}
    </GiayBaoNoSearchContext.Provider>
  );
}
